function parseCurrency(value: string | number) {
  if (typeof value === 'number') {
    return value;
  }

  if (!value || value === '') return 0;

  return parseFloat(value.replace(',', '.'));
}

export default parseCurrency;
